/**
 * @fileoverview
 * Loading Service - Manages global loading state
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private activeRequests = 0;
  private readonly loadingSignal = signal<boolean>(false);

  readonly loading = this.loadingSignal.asReadonly();

  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.loadingSignal.set(true);
    }
  }

  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this.loadingSignal.set(false);
    }
  }

  reset(): void {
    this.activeRequests = 0;
    this.loadingSignal.set(false);
  }
}
